// Wavy Text Effect - Improved for Shopify Theme Editor
(function() {
  
  function applyWavyEffect() {
    // Select only sub-headings within collection-list sections
    const subHeadings = document.querySelectorAll('.section-collection-list .title-wrapper-with-link .sub-heading');
    
    subHeadings.forEach(function(heading) {
      // Skip if already processed
      if (heading.classList.contains('wavy-animation')) {
        return;
      }
      
      // Get the text content
      const text = heading.textContent.trim();
      
      // Skip if empty
      if (!text) {
        return;
      }
      
      // Clear the heading
      heading.textContent = '';
      
      // Add wavy-animation class
      heading.classList.add('wavy-animation');
      
      // Optional: Add different wave styles
      // heading.classList.add('dramatic');  // More dramatic wave
      // heading.classList.add('flow');      // Smooth flowing wave
      // heading.classList.add('ocean');     // Ocean wave effect
      
      // Split text into individual characters while preserving spaces
      const chars = text.split('');
      
      chars.forEach(function(char, index) {
        const span = document.createElement('span');
        
        // Handle spaces properly
        if (char === ' ') {
          span.innerHTML = '&nbsp;'; // Non-breaking space
          span.style.marginRight = '0.3em'; // Add extra space between words
        } else {
          span.textContent = char;
        }
        
        // Set CSS variable for animation delay
        span.style.setProperty('--i', index);
        
        heading.appendChild(span);
      });
    });
  }
  
  // Run on initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyWavyEffect);
  } else {
    applyWavyEffect();
  }
  
  // For Shopify Theme Editor - re-apply when sections are updated
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      setTimeout(applyWavyEffect, 100);
    });
    
    document.addEventListener('shopify:section:reorder', function(event) {
      setTimeout(applyWavyEffect, 100);
    });
    
    // Watch for content changes in the editor
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          const target = mutation.target;
          // Check if the changed element is a sub-heading or contains one
          if (target.classList && target.classList.contains('sub-heading')) {
            // Reset the element
            target.classList.remove('wavy-animation');
            target.innerHTML = target.textContent;
            setTimeout(applyWavyEffect, 50);
          } else if (target.querySelector && target.querySelector('.sub-heading')) {
            setTimeout(applyWavyEffect, 50);
          }
        }
      });
    });
    
    // Observe the entire document for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
  
})();